// SPDX-License-Identifier: AGPL-3.0-or-later

import kitStyles from '@app/features/app/components/dialogs/shared/SettingsKit.module.css';
import {SettingsLinkRow} from '@app/features/app/components/dialogs/shared/SettingsRow';
import * as ModalCommands from '@app/features/ui/commands/ModalCommands';
import {modal} from '@app/features/ui/commands/ModalCommands';
import {TrashIcon} from '@app/features/ui/icons/Icons';
import {
	DataRequestModal,
	DELETE_TAB_DESCRIPTION,
} from '@app/features/user/components/modals/tabs/privacy_safety_tab/data_request_modal/DataRequestModal';
import {Trans, useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import type React from 'react';
import {useCallback} from 'react';

export const DataDeletionTabContent: React.FC = observer(() => {
	const {i18n} = useLingui();
	const handleOpen = useCallback(() => {
		ModalCommands.push(
			modal(() => (
				<DataRequestModal variant="delete" data-flx="user.privacy-safety-tab.data-deletion-tab.data-request-modal" />
			)),
		);
	}, []);
	return (
		<SettingsLinkRow
			icon={<TrashIcon size={20} />}
			title={<Trans>Delete my messages</Trans>}
			description={i18n._(DELETE_TAB_DESCRIPTION)}
			onClick={handleOpen}
			className={kitStyles.dangerRow}
			data-flx="user.privacy-safety-tab.data-deletion-tab.data-deletion-tab-content.button.open-modal"
		/>
	);
});
